import { Button, Typography } from '@navi/web-ui/lib/primitives';
import styles from './index.module.scss';
import { ArrowRightIcon, DownloadIcon } from '@navi/web-ui/lib/icons';
import { useNavigate } from 'react-router-dom';
import { DateFormat } from '@cp/src/utils/DateHelper';
import dayjs from 'dayjs';
import { ValidationData } from '../../interface';
import { useMemo } from 'react';
import { APP_ROUTES_PATHS_WITH_PATH_PARAM } from '@cp/src/layout/Routes';
import { InputValidationType } from '../../types';
import { useSelector } from 'react-redux';
import { RootState } from '@cp/src/store';

interface IValidationCardProps {
  item: ValidationData;
}

const ValidationCard = (props: IValidationCardProps) => {
  const { item } = props;
  const { key, name, comments, color, errorReport, metadata } = item || {};
  const navigate = useNavigate();

  const showAgencyCappingUpdateButton =
    useSelector((store: RootState) => store.common.featureFlags?.agencyCappingEnabled) || false;
  const showServicibilityUpdateButton =
    useSelector((store: RootState) => store.common.featureFlags?.agencyServiceability) || false;

  const { showUpdateButton, updateUrl } = useMemo(() => {
    if (key === InputValidationType.AGENCY_CAPPING && showAgencyCappingUpdateButton) {
      return {
        showUpdateButton: true,
        updateUrl: APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_capping
      };
    }

    if (key === InputValidationType.PINCODE_SERVICEABILITY && showServicibilityUpdateButton) {
      return {
        showUpdateButton: true,
        updateUrl: APP_ROUTES_PATHS_WITH_PATH_PARAM.AGENCY_UTILITIES.agency_pincode_mapping
      };
    }
    return { showUpdateButton: false, updateUrl: '' };
  }, [key]);

  return (
    <div className={styles.validationsCard}>
      <div className={styles.header}>
        <Typography variant="h4" color="var(--navi-color-gray-c2)">
          {name}
        </Typography>
        {showUpdateButton && (
          <Button
            variant="text"
            size="medium"
            endAdornment={<ArrowRightIcon color="var(--blue-base)" size="sm" />}
            onClick={() => {
              navigate(updateUrl);
            }}
          >
            Update
          </Button>
        )}
      </div>
      <div className="px-4 py-3">
        <div className="flex items-center justify-between mb-4">
          <Typography variant="h4" color={color}>
            {comments}
          </Typography>
          {errorReport && (
            <div
              onClick={() => {
                window.open(errorReport, '_blank');
              }}
              className="cursor-pointer"
            >
              <DownloadIcon color="var(--blue-base)" size="sm" />
            </div>
          )}
        </div>
        <Typography className="text-xs" variant="h5" color="var(--navi-color-gray-c3)">
          Last updated:{' '}
          <Typography as="span" className="text-xs" variant="h5" color="var(--navi-color-gray-c2)">
            {`${
              metadata?.lastUpdatedAt
                ? dayjs(metadata?.lastUpdatedAt).format(DateFormat.DD_MMM_hh_mm_A)
                : '-'
            } (${metadata?.lastUpdatedBy})`}
          </Typography>
        </Typography>
      </div>
    </div>
  );
};

export default ValidationCard;
